import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({
    addUrlParams: true
});

import * as overlay from './scripts/overlay'
overlay.init();

import * as lightbox from '@elements/lightbox';
lightbox.init({
    plugins: ['video'],
    mobileSettings: {
        controls: true,
        showCloseIcon: true
    }
});